import { connect } from 'react-redux';

import { getCoworkingOffersAvailable } from 'shared/store/coworking/selectors/dump/getCoworkingOffersAvailable';

import { getCoworkingWorkplacesSelector } from '../../store/coworking/selectors/dump/getCoworkingWorkplacesSelector';
import { IApplicationState } from '../../types/redux';

import { AvailableSpaces as AvailableSpacesComponent } from './AvailableSpaces';

export const mapState = (state: IApplicationState) => ({
  isFlexOfficeAvailable: getCoworkingOffersAvailable(state),
  workplaces: getCoworkingWorkplacesSelector(state),
});

export const AvailableSpaces = connect(mapState)(AvailableSpacesComponent);
